import { render, staticRenderFns } from "./TarimaDevolucionTableComponent.vue?vue&type=template&id=c80c821e&"
import script from "./TarimaDevolucionTableComponent.vue?vue&type=script&lang=js&"
export * from "./TarimaDevolucionTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports